import { createSlice } from '@reduxjs/toolkit'
import { IChangesState } from './types'

const initialState: IChangesState = {
  numberOfChanges: 0,
}

const changesSlice = createSlice({
  name: 'changes',
  initialState,
  reducers: {
    addChange: (state, { payload }) => {
      if (state.numberOfChanges == undefined) {
        state.numberOfChanges = payload.value
        return
      }

      if (state.numberOfChanges + payload.value < 0) {
        state.numberOfChanges = 0
        return
      }
      state.numberOfChanges = state.numberOfChanges + payload.value
    },
    resetChanges: state => {
      state.numberOfChanges = 0
    },
  },
  extraReducers: {},
})

export const { addChange, resetChanges } = changesSlice.actions

export default changesSlice.reducer
